// extracted by mini-css-extract-plugin
export default {"block":"CommentsWindow_block__sHyjW","title":"CommentsWindow_title__rIitK"};